import { media } from '@rst/libs-ts'
import React from 'react'
import styled, { css } from 'styled-components'
import { color } from '../../atoms'
import { Button2 } from '../../atoms/buttons/button2'
import { FooterButtonType, FooterPropsType } from '../type'

export const Footer: React.FC<FooterPropsType> = ({ content, custom }) => {
	if (React.isValidElement(custom)) {
		return <>{custom}</>
	}

	if (React.isValidElement(content) || !content)
		return (
			<Wrapper className={'awesome-modal-footer'} isNotContent={!content}>
				{typeof content === 'function' ? content() : content || null}
			</Wrapper>
		)

	const content_ = content as FooterButtonType[]
	const { left, right } = (content_ as FooterButtonType[]).reduce(
		(acc, x) => {
			if (x.position === 'right') return { ...acc, right: [...acc.right, x] }
			return { ...acc, left: [...acc.left, x] }
		},
		{
			left: [] as FooterButtonType[],
			right: [] as FooterButtonType[],
		}
	)

	return (
		<Wrapper
			className={'awesome-modal-footer'}
			btnMode
			isNotContent={!content_.length}
		>
			<WrapperBtn>
				{left.map((x, ind) => (
					<Button2 key={ind} {...x}>
						{x.text}
					</Button2>
				))}
			</WrapperBtn>
			<WrapperBtn>
				{right.map((x, ind) => (
					<Button2 key={ind} {...x}>
						{x.text}
					</Button2>
				))}
			</WrapperBtn>
		</Wrapper>
	)
}

const Wrapper = styled.div<{ btnMode?: boolean; isNotContent?: boolean }>`
	padding: 20px 0 50px 0;
	border-radius: 16px;
	display: flex;
	${media.pure.less(media.size.sm)} {
		padding: 10px 0 20px 0;
		position: sticky;
		bottom: 0;
		background: ${color('gray-01')};
	}
	${({ btnMode }) =>
		btnMode &&
		css`
			justify-content: space-between;
			${media.pure.less(media.size.sm)} {
				flex-flow: column;
			}
		`};

	${({ isNotContent }) =>
		isNotContent &&
		css`
			padding-top: 0;
			position: relative;
			${media.pure.less(media.size.sm)} {
				position: relative;
			}
		`}
`

const WrapperBtn = styled.div`
	display: flex;
	& > button + button {
		margin-left: 10px;
	}
	${media.pure.less(media.size.sm)} {
		flex-flow: column;
		& + & {
			margin-top: 10px;
		}
		& > button + button {
			margin: 10px 0 0 0;
		}
	}
`
